import { render, staticRenderFns } from "./CanvasToolbarTop.vue?vue&type=template&id=059894b8&scoped=true"
import script from "./CanvasToolbarTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./CanvasToolbarTop.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CanvasToolbarTop.vue?vue&type=style&index=0&id=059894b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059894b8",
  null
  
)

export default component.exports